import React, { Component } from 'react';
import { NumericKeyboard } from 'numeric-keyboard/dist/numeric_keyboard.react';
import { withTranslation } from 'react-i18next';
import i18n from 'i18next';
import ReactSVG from 'react-svg';
import { Link, Redirect } from "react-router-dom";
import { Alert, UncontrolledDropdown, DropdownToggle, DropdownItem, DropdownMenu, Modal, ModalBody } from 'reactstrap';

import { getUserByPhone } from "./../../models/user";
import { getReservationsByUser, createReservation  } from "./../../models/reservation";
import { checkinReservation } from "./../../models/reservation";
import { getRoom } from "./../../models/room";
import { createPayment } from "./../../models/payment";
import moment from 'moment';
import Moment from 'react-moment';
import iconPrinter from "./../../assets/images/icon-printer.svg";
import iconClock from './../../assets/images/icon-clock.svg';
import iconClockExtra from './../../assets/images/icon-clock-extra.svg';
import iconSalon from './../../assets/images/icon-salon.svg';
import iconParking from './../../assets/images/icon-parking.svg';
import iconShower from './../../assets/images/icon-shower.svg';
import iconBath from './../../assets/images/icon-bath.svg';
import iconWheelchair from './../../assets/images/icon-wheelchair.svg';
import iconKallah from './../../assets/images/icon-kallah.svg';
import iconChabadBor from './../../assets/images/icon-chabad-bor.svg';
import iconSegula from './../../assets/images/icon-segula.svg';
import moneyOwed from "./../../assets/images/icon-money-owed.svg";
import Clock from './../../components/clock';
import ZmanTevilah from './../../components/zman-tevilah';
import Flipper from './../../components/flipper';
import Button from './../../components/button';
import LoaderSpinner from './../../assets/images/icon-loader-spinner.svg';
import ScreenSaver from '../../components/screensaver';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LanguageSelector from '../../components/language-selector';
import SignalR from '../../components/signalr';
import { SettingsContext } from './../../components/context';
import KioskAdmin from './../../components/kiosk-admin';
import CurrencyFormat from './../../components/snippets/currency-format';
import { logoImageAltText } from '../../global-props';
import PhoneInput from 'react-phone-number-input/input';
import KioskMerchandise from './partials/kioskMerch';
import KioskExcludedAttendant from './partials/kioskExcludedAttendant';
import FridayLocation from '../../components/fridayLocation';
import { getCountries, getCountryCallingCode, isPossiblePhoneNumber } from 'react-phone-number-input/input';
import enC from 'react-phone-number-input/locale/en.json'
import heC from 'react-phone-number-input/locale/he.json'

class KioskView extends Component {
  static contextType = SettingsContext;
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      reservationCode: "",
      currentScreen: "welcome",
      isSubmitting: false,
      requireFullPhoneNumber: false,
      hideScreensaver: false,
      time: moment().format(),
      bath: props.siteSettings.defaultSelectBath||false,
      handicapped: false,
      segula: false,
      doubleSlot: false,
      chabadBor: false,
      kallah: false,
      selectedCountry: 'IL',
      countryPrefix: '+972',
      walkinPhoneNumber: "",
      walkinUserId: null,
      fridayInfoRequired: false,
      modalFridayLocation: false,
      reservation: {}
    };

    this.preferredCountries = ['IL', 'US', 'FR', 'CA', 'GB'];
  
    this.handlePress = this.handlePress.bind(this);
    this.handleCheckin = this.handleCheckin.bind(this);
    this.handleScreenChange = this.handleScreenChange.bind(this);
    this.handleEntryDoorOpened = this.handleEntryDoorOpened.bind(this);
    this.handleKioskPrinterSelected = this.handleKioskPrinterSelected.bind(this);
    this.handleChargeTerminalICount = this.handleChargeTerminalICount.bind(this);
    this.handleRoomTypeChange = this.handleRoomTypeChange.bind(this);
    this.handleCreateReservation = this.handleCreateReservation.bind(this);
    this.handleUpdateReservation = this.handleUpdateReservation.bind(this);
    this.handlePhonePress = this.handlePhonePress.bind(this);
    this.handleChangeCountry = this.handleChangeCountry.bind(this);
    this.modalToggleFridayLocation = this.modalToggleFridayLocation.bind(this);
    this.fridayCanContinue = this.fridayCanContinue.bind(this);
  }

  componentDidMount() {
    this.savedContext = this.context;
    this.setupDefaultCountry();

    this.setUpTick();
    let savedPrinter = localStorage.getItem('selectedPrinter');
    if ( savedPrinter ) {
      this.setState({savedPrinter});
      return;
    }
  }

  componentDidUpdate() {
    if (this.context!==null && this.savedContext.settings !== this.context.settings) {
      if (this.context.settings!==null) {
        this.setupDefaultCountry();
      }
    }
    this.savedContext = this.context;
  }
  
  componentWillUnmount() {
    clearTimeout(this.timer);
    clearInterval(this.intervalID);
  }
  setUpTick() {
    this.intervalID = setInterval(
      () => this.tick(),
      1000
    );
  }

  tick() {
    this.setState({
      time: moment().format(),
    });
  }

  setupDefaultCountry() {
    const { settings } = this.context;
    if(settings!==null){
      const country = (settings&&settings.countryCode&&settings.countryCode.value&&settings.countryCode.value.toUpperCase())||"IL";
      this.setState({
        selectedCountry: country,
        countryPrefix: '+' + getCountryCallingCode(country),
      })
    }
  }

  handleChangeCountry(country) {
    this.setState({selectedCountry: country, countryPrefix: '+' + getCountryCallingCode(country)});
  }

  handlePhonePress(key) {
    let input = this.state.walkinPhoneNumber;
    if ( key === 'del' && input.length!==0 ) { input = input.slice(0, -1); }
    if ( typeof key === 'number' && input.length<15 ) { input = input + key; }
    this.setState({
      walkinPhoneNumber: input
    })
    if ( (key === 'enter' && input.length>=4) ) {
      this.setState({isSubmitting: true});
      this.retrieveUserByPhone(input)
        .then(users => {
          if ( users.length===1 ) {
            this.retrieveReservationsByUser(users[0].id, true)
          } else if ( users.length > 1 ) {
            return this.handleScreenChange("error");
          } else if(users.length===0){
            return this.handleScreenChange("walkinReservation");
          } else {
            return this.handleScreenChange("error");
          }
        }, error => this.handleScreenChange("error"));
    }

  }


  retrieveUserByPhone(phone) {
    return new Promise((resolve, reject) => {
      getUserByPhone(phone, true)
      .then(
        result => resolve(result),
        error => reject(error)
      );
    })
  }

  retrieveReservationsByUser(id, walkin=false) {
    const { selCardReader, settings } = this.context;
    getReservationsByUser(id)
      .then(
        result => {
          let prevDay = parseInt(moment().subtract(settings&&settings.offset&&settings.offset.value,'seconds').format('HH')) < 5;
          let resTodayReservedPaid = result.filter(res=>['Reserved','Assigned','Waiting'].includes(res.reservationStatus)&&moment(res.reservationDate).isSame(moment().subtract(prevDay?1:0,'days').subtract(settings&&settings.offset&&settings.offset.value,'seconds').startOf('day'))&&(res.paid||selCardReader));
          let resToday = result.filter(res=>['Reserved','Assigned','Waiting'].includes(res.reservationStatus)&&moment(res.reservationDate).isSame(moment().subtract(prevDay?1:0,'days').subtract(settings&&settings.offset&&settings.offset.value,'seconds').startOf('day'))&&(selCardReader));
          if ( resTodayReservedPaid.length===1 ) {
            this.setState({
              reservation: resTodayReservedPaid.pop(),
            },() => {
              const { reservation } = this.state;
              if (reservation.kallah) {
                this.roomTypeDisplay = { name: 'Kallah', icon: iconKallah, price: 'priceKallah' }
              } else if (reservation.segula) {
                this.roomTypeDisplay = { name: 'Segula', icon: iconSegula, price: 'priceSegula' }
              } else if (reservation.handicapped) {
                this.roomTypeDisplay = { name: "Accessible", icon: iconWheelchair, priceName: 'priceBath' }
              } else if (reservation.bath) {
                this.roomTypeDisplay = { name: "Bath", icon: iconBath, priceName: reservation.useDiscountPrice? 'priceBathDiscount' :'priceBath' }
              } else {
                this.roomTypeDisplay = { name: "Shower", icon: iconShower, priceName: reservation.useDiscountPrice? 'priceShowerDiscount' : 'priceShower' }
              }
              this.setState({roomTypeDisplay: this.roomTypeDisplay});
            })
            return this.handleScreenChange("confirm");
          } else if( resToday.length===0 && walkin ) {
            this.setState({walkinUserId: id})
            return this.handleScreenChange("walkinReservation");
          }
          return this.handleScreenChange("error");
        },
        error => {
          this.setState({
            errorReservation: error
          });
        }
      );
  }

  handlePress(key) {
    const { settings } = this.context;
    const { requireFullPhoneNumber } = this.state;
    const defaultLanguage = settings&&settings.defaultLanguage&&settings.defaultLanguage.value
    let input = this.state.reservationCode;
    if ( key === 'del' && input.length!==0 ) { input = input.slice(0, -1); }
    if ( typeof key === 'number' && (requireFullPhoneNumber?input.length<15:input.length<4) ) { input = input + key; }
    this.setState({
      reservationCode: input
    })
    clearTimeout(this.timeoutCode);
    this.timeoutCode = setTimeout(() => {
      this.handleScreenChange("welcome", { resetReservationCode: true })
      i18n.changeLanguage(defaultLanguage);
    },15000);
    if ( (key === 'enter' && input.length>=4) || (!requireFullPhoneNumber&&input.length>=4) ) {
      this.setState({isSubmitting: true});
      this.retrieveUserByPhone(input)
        .then(users => {
          if ( users.length===1 ) {
            this.retrieveReservationsByUser(users[0].id)
          } else if ( users.length > 1 ) {
            if ( input.length <= 4 ) {
              this.setState({
                reservationCode: "",
                requireFullPhoneNumber: true,
                isSubmitting: false,
              })
            } else {
              return this.handleScreenChange("error");
            }
          } else {
            return this.handleScreenChange("error");
          }
        }, error => this.handleScreenChange("error"));
    }
  }

  handleChargeTerminalICount() {
    const { selCardReader } = this.context;
    let payment = {
      method: 'creditcard',
      amt: this.state.reservation.balance,
      reservationId: this.state.reservation.reservationId,
      paymentInfo: {cardReaderId: selCardReader},
      useDiscountPrice: this.state.reservation.useDiscountPrice
    }
    this.handleCreatePayment(payment);
  }

  handleCreatePayment(payment) {
    this.setState({
      isSubmitting: true,
      error: null,
    })
    createPayment(payment)
      .then(result => {
        if ( result.paid ) {
          this.handleCheckin();
        }
      }, error => {
        this.setState({error: error.stripeErrorMessage?error.stripeErrorMessage:error.errorMessage,isSubmitting: false});
      })
  }

  handleCheckin() {
    this.setState({isSubmitting: true});
    let printerId = this.state.savedPrinter;
    checkinReservation(this.state.reservation.reservationId, {printerId}, i18n.language)
      .then(result => {
        this.setState({isSubmitting: false});
        let res = result;
        this.setState({
          reservation: res
        })
        this.handleScreenChange("end");
      }, error => this.handleScreenChange("error"));
  }

  toggleLanguage = (lang) => {
    i18n.changeLanguage(lang);
    moment.locale(lang);
    localStorage.setItem('selectedLanguage', lang);
  }

  handleScreenChange(screen, args, lang) {
    const { settings } = this.context;
    const defaultLanguage = settings&&settings.defaultLanguage&&settings.defaultLanguage.value

    let resetReservationCode = false;
    if ( args!=null ) {
      if ( args.resetReservationCode!==null ) {
        resetReservationCode = args.resetReservationCode;
      }
    }
    if(lang){
      this.toggleLanguage(lang);
    }
    if (screen === "end" || screen === "error") {
      setTimeout(() => {
        this.handleScreenChange("welcome", { resetReservationCode: true })
      },10000);
    } 
    if (screen === "confirm") {
      this.timeoutConfirm = setTimeout(() => {
        this.handleScreenChange("welcome", { resetReservationCode: true })
      },60000);
    } else {
      clearTimeout(this.timeoutConfirm);
    }
    if (screen === "pay") {
      this.timeoutPay = setTimeout(() => {
        this.handleScreenChange("welcome", { resetReservationCode: true })
      },120000);
    } else {
      clearTimeout(this.timeoutConfirm);
    }
    if (screen === "print") {
      this.timeoutPrint = setTimeout(() => {
        this.handleScreenChange("welcome", { resetReservationCode: true })
      },60000);
    } else {
      clearTimeout(this.timeoutPrint);
    }
    if (screen === "merchandise") {
      this.timeoutMerchandise = setTimeout(() => {
        this.handleScreenChange("welcome", { resetReservationCode: true })
      },120000);
    } else {
      clearTimeout(this.timeoutMerchandise);
    }
    if (screen === "excludedAttendant") {
      this.timeoutExcludedAttendant = setTimeout(() => {
        this.handleScreenChange("welcome", { resetReservationCode: true })
      },120000);
    } else {
      clearTimeout(this.timeoutExcludedAttendant);
    }
    if (screen === "walkinPhone") {
      this.timeoutWalkinPhone = setTimeout(() => {
        this.handleScreenChange("welcome", { resetReservationCode: true })
      },120000);
    } else {
      clearTimeout(this.timeoutWalkinPhone);
    }
    if (screen === "walkinReservation") {
      if(settings&&settings.shabbosMode&&settings.shabbosMode.value&&settings.fridayLocationSystem&&settings.fridayLocationSystem.value==="True"&&settings.fridayLocationSystemRequired&&settings.fridayLocationSystemRequired.value==="True"){
        this.setState({fridayInfoRequired: true, modalFridayLocation: true});
      }
      this.timeoutWalkinReservation = setTimeout(() => {
        this.handleScreenChange("welcome", { resetReservationCode: true })
      },120000);
    } else {
      clearTimeout(this.timeoutwalkinReservation);
    }
    if (screen === "enterCode") {
      console.log('trigger');
      this.timeoutCode = setTimeout(() => {
        this.handleScreenChange("welcome", { resetReservationCode: true })
      },15000);
    } else {
      clearTimeout(this.timeoutCode);
    }
    if (screen === "updateAtReception") {
      console.log('trigger');
      this.timeoutCode = setTimeout(() => {
        this.handleScreenChange("welcome", { resetReservationCode: true })
      },60000);
    } else {
      clearTimeout(this.timeoutCode);
    }
    if (screen === "welcome") {
      this.toggleLanguage(defaultLanguage);
      localStorage.setItem('selectedLanguage', defaultLanguage)
    }
    const country = (settings&&settings.countryCode&&settings.countryCode.value&&settings.countryCode.value.toUpperCase())||"IL";
    this.setState({
      currentScreen: screen,
      isSubmitting: false,
      requireFullPhoneNumber: resetReservationCode ? false : this.state.requireFullPhoneNumber,
      reservationCode: resetReservationCode ? "" : this.state.reservationCode,
      walkinPhoneNumber: resetReservationCode? "" : this.state.walkinPhoneNumber,
      walkinUserId: resetReservationCode? null : this.state.walkinUserId,
      selectedCountry: resetReservationCode?country: this.state.selectedCountry,
      countryPrefix: resetReservationCode?getCountryCallingCode(country): this.state.countryPrefix,
      bath: resetReservationCode?(this.props.siteSettings.defaultSelectBath||false):this.state.bath,
      handicapped: resetReservationCode ? false : this.state.handicapped,
      segula: resetReservationCode ? false : this.state.segula,
      doubleSlot: resetReservationCode ? false : this.state.doubleSlot,
      chabadBor: resetReservationCode ? false : this.state.chabadBor,
      reservation: resetReservationCode ? {} : this.state.reservation,
      error: null
    })
    if(screen !== "walkinReservation"){
      this.setState({
        modalFridayLocation: resetReservationCode ? false : this.state.modalFridayLocation,
      })
    }
  }

  handleKioskPrinterSelected = (savedPrinter) => {
    this.setState({savedPrinter})
  }

  handleEntryDoorOpened() {
    if (this.props.id==='lobby') {
      this.setState({
        hideScreensaver: true,
      }, () => {
        this.timer = setTimeout(()=>{this.setState({hideScreensaver:false})}, 2 * 60 * 1000);
      });
    }
  }

  handleRoomTypeChange(value, type) {
    let option = value.name;
    let prevOptionState = this.state[option];
    let options = {};
    if ( type==='type' ) {
      options = { bath: false, handicapped: false, kallah: false, segula: false };
      if ( this.state[option] ) return;
      if ( option==='shower' ) {
        if ( !this.state.bath && !this.state.kallah && !this.state.handicapped && !this.state.segula ) return;
        option = 'bath';
        prevOptionState = !prevOptionState;
      }
    }
    options = {...options, [option]: !prevOptionState};
    this.setState(options);
  }

  handleCreateReservation() {
    let res = {
      ...this.state.reservation,
      phoneNumber: this.state.walkinUserId?null:(this.state.walkinPhoneNumber?this.state.countryPrefix+this.state.walkinPhoneNumber:null),
      userId: this.state.walkinUserId,
      roomType: this.state.handicapped ? "wheelchair" : (this.state.bath?"bath":"shower"),
      bath: this.state.bath,
      handicapped: this.state.handicapped,
      segula: this.state.segula,
      doubleSlot: this.state.doubleSlot,
      chabadBor: this.state.chabadBor,
    }

    this.setState({
      isSubmitting: true,
    })

    //Create/modify reservation
    createReservation(res)
      .then(result => {
        this.setState({
          reservation: result
        }, () => this.handleScreenChange(result.balance>0?'pay':'print'));
      }, error => {
        this.setState({
          error,
          isSubmitting: false,
        })
      });
  }

  handleUpdateReservation(res){
    this.setState({reservation: res});
  }

  modalToggleFridayLocation() {
    const { settings } = this.context;
    if(settings&&settings.fridayLocationSystemRequired&&settings.fridayLocationSystemRequired.value==="True"&&!(this.state.reservation&&this.state.reservation.fridayLocationId)){
      this.setState({modalFridayLocation: true});
    } else {
      this.setState({modalFridayLocation: !this.state.modalFridayLocation});
    }  
  }

  fridayCanContinue() {
    this.setState({fridayInfoRequired: false});
  }

  render() {
    const { t, logo, logoImageAltText, siteSettings, localProps } = this.props;
    const { reservationCode, walkinPhoneNumber, selectedCountry, countryPrefix, currentScreen, reservation, roomTypeDisplay, requireFullPhoneNumber, isSubmitting, savedPrinter, hideScreensaver, fridayInfoRequired, error } = this.state;
    const he = i18n.getFixedT('he');
    const en = i18n.getFixedT('en');

    let screen = null;
    switch ( currentScreen ) {
      case "welcome":
        screen = <div className="w-100">
          <SettingsContext.Consumer>
            {({settings}) => {
            if(settings){
              let shkia = settings.shkia ? settings.shkia.value : null;
              let beforeShkia = moment(this.state.time).subtract(settings.offset&&settings.offset.value,'seconds').isBefore(moment(shkia));
              let beforeFridayPrepClose = moment(this.state.time).subtract(settings.offset&&settings.offset.value,'seconds').isBefore(moment(shkia).subtract(settings.fridayPrepClosingMinutesBeforeShkia&&settings.fridayPrepClosingMinutesBeforeShkia.value,'minutes'));
              if((settings.shabbosMode && settings.shabbosMode.value===false) || ((settings.shabbosMode && settings.shabbosMode.value===true && settings.fridayPrep && settings.fridayPrep.value==="False" && beforeShkia) || (settings.shabbosMode && settings.shabbosMode.value===true && settings.fridayPrep && settings.fridayPrep.value==="True" && beforeFridayPrepClose))){
                let openTime = settings.openTime ? settings.openTime.value : null;
                let checkinbeforeopen = settings.checkinBeforeOpenMinutes && settings.checkinBeforeOpenMinutes.value ? settings.checkinBeforeOpenMinutes.value : null;
                let entryCutoff = moment(openTime).subtract(checkinbeforeopen,'m');
                return checkinbeforeopen && moment(this.state.time).subtract(settings.offset&&settings.offset.value,'seconds').isBefore(moment(entryCutoff))?
                <>
                  {!hideScreensaver?
                  <ScreenSaver text="Touch screen to begin" logo={this.props.logoWhite} logoImageAltText={this.props.logoImageAltText} />
                  :null}
                  {!siteSettings.onlyEnglishOnKiosk?
                    <div className="instructions">
                      <h2 className="">{he('Please Wait Here')}</h2>
                      <h3 className="">{he('The Mikvah is not open yet.')}</h3> 
                      <h3 className="">{he('We will open at') + " "} 
                      <Moment className="time" format={he("h:mm A")} element="span">{entryCutoff}</Moment>
                      </h3>
                    </div>
                  :null}
                 <div className="instructions">
                  <h2 className="">{en('Please Wait Here')}</h2>
                  <h3 className="">{en('The Mikvah is not open yet.')}</h3> 
                  <h3 className="">{en('We will open at')  + " "} 
                  <Moment className="time" format={en("h:mm A")} element="span">{entryCutoff}</Moment>
                  </h3>
                </div>
                </>
                : <>
                {!siteSettings.onlyEnglishOnKiosk?
                  <div className="instructions">
                    <h1 className="mb-3">{he('Check In')}</h1>
                    <div className="btn-row">
                      <Button type="primary" size="lg" onClick={() => this.handleScreenChange(siteSettings.onlyKioskGuestWalkin?"walkinReservation":"enterCode", null, "he")}>{he('Get Started')}</Button>
                    </div>
                  </div>
                :null}
                <div className="instructions">
                  <h1 className="mb-3">{en('Check In')}</h1>
                  <div className="btn-row">
                    <Button type="primary" size="lg" onClick={() => this.handleScreenChange(siteSettings.onlyKioskGuestWalkin?"walkinReservation":"enterCode",null, "en")}>{en('Get Started')}</Button>
                  </div>
                </div>
                </>
              } else {
                return <ScreenSaver text={"Good " + (settings.scheduleType&&settings.scheduleType.value==="Friday"?"Shabbos":"Yom Tov")} logo={this.props.logoWhite} logoImageAltText={this.props.logoImageAltText} />
              }
          }}}
        </SettingsContext.Consumer>
        </div>
        break;
      case "enterCode":
        screen = <div>
          <SettingsContext.Consumer>
            {({selCardReader, settings}) => {
              if(selCardReader&&settings&&settings.reservationsAllowWalkInKiosk&&settings.reservationsAllowWalkInKiosk.value==='True'){
                return <Button className="mb-4" size="lg" type="secondary" onClick={() => this.handleScreenChange('walkinPhone')}>{t("I don't have a reservation")}</Button>
              }
            }}
          </SettingsContext.Consumer>
          {requireFullPhoneNumber?
            <div className="instructions">
              {t("kioskKeypadInsructionsFullNumber")}
            </div>
          :
            <div className="instructions">
              {t("kioskKeypadInsructions")}
            </div>
          }
          <div className="wrapper-phonenumber">
            {isSubmitting?
              <ReactSVG className="loader-spinner dark large" src={LoaderSpinner} />
            :
              <div className={"flippers"}>
              {requireFullPhoneNumber?
                <Flipper type="full" text={reservationCode} />
              :
                [0,0,0,0].map((v,i) => {
                  return <Flipper type="single" key={i} text={reservationCode[i]} />
                })
              }
              </div>
            }
          </div>
          <NumericKeyboard layout="tel" onPress={this.handlePress} />
        </div>
        break;
        case "walkinPhone":
          screen = <SettingsContext.Consumer>
          {({settings}) => <>
            {error!==null?<div className="checkin-message"><Alert color="danger">{t(error)}</Alert></div>:null}
  
            <div className="instructions">{t("kioskKeypadWalkinInstructions")}</div>
            <div className="form-group input-group dir-ltr justify-content-center mb-5">
              <div className="input-group-prepend">
                <UncontrolledDropdown className="dropdown-countries">
                  <DropdownToggle outline color="primary" caret>
                    +{getCountryCallingCode(selectedCountry)}
                  </DropdownToggle>
                  <DropdownMenu>
                    {this.preferredCountries.map((country) => (
                      <DropdownItem key={country} className="d-flex justify-content-between" active={country===selectedCountry} onClick={()=>this.handleChangeCountry(country)}>
                        <div>{i18n.language=="en"?enC[country]:heC[country]}</div>
                        <div>+{getCountryCallingCode(country)}</div>
                      </DropdownItem>                        
                    ))}
                    <DropdownItem divider />                
                    {getCountries().filter(country=>!this.preferredCountries.includes(country)).map((country) => (
                      <DropdownItem key={country} className="d-flex justify-content-between" active={country===selectedCountry} onClick={()=>this.handleChangeCountry(country)}>
                        <div>{i18n.language=="en"?enC[country]:heC[country]}</div>
                        <div>+{getCountryCallingCode(country)}</div>
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
              <PhoneInput className="walkinPhone" onChange={() => false} international={true} value={countryPrefix + walkinPhoneNumber} country={this.state.selectedCountry} error={walkinPhoneNumber ? (isPossiblePhoneNumber(countryPrefix + walkinPhoneNumber) ? undefined : 'Invalid phone number') : 'Phone number required'} placeholder={t("Mobile Number")} />
            </div>
            <NumericKeyboard layout="tel" onPress={this.handlePhonePress} />
            <Button className="mt-3" type="outline-primary" onClick={() => this.handleScreenChange('enterCode', { resetReservationCode: true })}>{t('Cancel')}</Button>
          </>}
        </SettingsContext.Consumer>
        break
        case "walkinReservation":
          screen = <SettingsContext.Consumer>
          {({settings}) => <>
            {error!==null?<div className="checkin-message"><Alert color="danger">{t(error)}</Alert></div>:null}
            {settings!== null?<>
            <div className="container-checkin">
              <div className="checkin-roomType">
                <div className="title">{t("Select Room Type")}</div>
                <div className="d-flex justify-content-center">
                  {[
                    {title:"Shower", name:"shower", icon: iconShower, price: settings.priceShower.value, minutes: settings.reservationMinutesShower.value },
                    {title:"Bath", name:"bath", icon: iconBath, price: settings.priceBath.value, minutes: settings.reservationMinutesBath.value },
                    // {title:"Kallah", name:"kallah", icon: iconKallah, price: settings.priceKallah.value, minutes: settings.reservationMinutesBath.value },
                    {title:"Accessible", name:"handicapped", icon: iconWheelchair, price: settings.priceBath.value, minutes: settings.reservationMinutesBath.value, hide: !(settings.roomsAvailableHandicapped&&(!settings.roomsAvailableHandicapped.value||settings.roomsAvailableHandicapped.value!=='0')) },
                    {title: "Segula", name: "segula",  icon: iconSegula, price: (settings.priceSegula&&settings.priceSegula.value), minutes: (settings.reservationMinutesSegula&&settings.reservationMinutesSegula.value), hide: !(settings.priceSegula&&settings.priceSegula.value) },
                  ].map((type,i) => {
                    let active = this.state[type.name];
                    if ( type.name==='shower' ) { active = (!this.state.bath&&!this.state.kallah&&!this.state.handicapped&&!this.state.segula) }
                    if ( type.name==='bath' ) { active = (this.state.bath&&!this.state.kallah&&!this.state.handicapped&&!this.state.segula) }
                    return !type.hide?(<div key={i}>
                      <Button type="circle" active={active} icon={<ReactSVG src={type.icon} />} value={type} xtext={type.title} key={i} onClick={() => this.handleRoomTypeChange(type, "type")} />
                      <div className="btn-text">{t(type.title)}</div><div className="price"><CurrencyFormat value={type.price} /></div>
                      {type.minutes&&!siteSettings.hideResMinutesOnKiosk?<div className="price">{type.minutes} {t("min")}</div>:null}
                      </div>):null;
                  })}
                </div>
              </div>
              {!siteSettings.hideExtraTimeOnKiosk||!(settings&&settings.roomsAvailableChabad&&(!settings.roomsAvailableChabad.value||settings.roomsAvailableChabad.value==='0'))?
              <div className="checkin-roomType">
                <div className="title">{t("Additional Options")}</div>
                <div className="d-flex justify-content-center">
                  {[
                    // {title:"Parking", name:"parking", icon: iconParking, price: settings.priceParking.value },
                    {title:"Extra Time", name:"doubleSlot", icon: iconClockExtra, price: settings.priceDoubleSlot.value, minutes: settings.reservationMinutesDoubleSlot.value, hide: siteSettings.hideExtraTimeOnKiosk },
                    {title:"Chabad Bor", name:"chabadBor", icon: iconChabadBor, hide: (settings&&settings.roomsAvailableChabad&&(!settings.roomsAvailableChabad.value||settings.roomsAvailableChabad.value==='0')) },
                  ].map((type,i) => {
                    return !type.hide?<div key={i}><Button type="circle" active={this.state[type.name]} icon={<ReactSVG src={type.icon} />} value={type} xtext={type.title} onClick={() => this.handleRoomTypeChange(type, "option")} /><div className="btn-text">{t(type.title)}</div><div className="price"><CurrencyFormat value={type.price} /></div>{type.minutes?<div className="price">+{type.minutes} {t("min")}</div>:null}</div>:null;
                  })}
                </div>
              </div>
              :null}
            </div>
            <div className="modal-footer flex-column">
              {settings.fridayLocationSystem&&settings.fridayLocationSystem.value==="True"&&settings.shabbosMode&&settings.shabbosMode.value?<div className="mb-3 cursor-pointer text-underline" onClick={this.modalToggleFridayLocation}>{reservation.fridayLocationId?t("Update Friday Location"):t("Add Friday Location")}</div>:null}
              <Button type="secondary" size="lg" loading={isSubmitting} onClick={this.handleCreateReservation} disabled={fridayInfoRequired}>{t("Continue")}</Button>
              <Button className="mt-3" type="outline-primary" onClick={() => this.handleScreenChange(siteSettings.onlyKioskGuestWalkin?'welcome':'enterCode', { resetReservationCode: true })}>{t('Cancel')}</Button>
            </div>
            </>:null}
          </>}
        </SettingsContext.Consumer>
        break
      case "confirm":
        screen = <div>
          <div className="instructions">
            {t('kioskReviewReservationTitle')}
          </div>
          <SettingsContext.Consumer>
            {({settings}) => {
            if(settings){
              let reservationMinutesTotal;

              if (settings!==null&&reservation.reservationId) {
                let reservationMinutes = parseFloat(settings['reservationMinutes'+(reservation.bath?'Bath':'Shower')].value);
                let reservationMinutesDoubleSlot = parseFloat(settings.reservationMinutesDoubleSlot.value);
                reservationMinutesTotal = reservationMinutes + (reservation.doubleSlot ? reservationMinutesDoubleSlot : 0);
              }          
              return <>
              <div className="checkin-reservation">
                <div className="title">{t("Reservation")}</div>
                <div className="reservation-number">{reservation.reservationCode}</div>
            <ul className="reservation-summary">
              <li>
                <div className="icon">
                  <ReactSVG src={iconClock} />
                </div>
                <Moment format={t("h:mma")}>{reservation.reservationTime}</Moment>-
                <Moment format={t("h:mma")} add={{minutes: reservationMinutesTotal}}>{reservation.reservationTime}</Moment>
              </li>
              {roomTypeDisplay?
                <li>
                  <div className="icon">
                    <ReactSVG src={roomTypeDisplay.icon} />
                  </div>
                  <span>{t("Room Type")}: <span className="text-capitalize">{t(roomTypeDisplay.name)}</span></span>
                </li>
              :null}
              {reservation.parking?
              <li>
                <div className="icon">
                  <ReactSVG src={iconParking} />
                </div>
                {reservation.parking?t("Parking"):t("Walking")}
              </li>
              :null}
              {reservation.salonBoth?
                <li>
                  <div className="icon">
                    <ReactSVG src={iconSalon} />
                  </div>
                  {t("Mani+Pedi")}
                </li>
              :(reservation.salonManicure?
                <li>
                  <div className="icon">
                    <ReactSVG src={iconSalon} />
                  </div>
                  {t("Manicure")}
                </li>                  
              :null)}
              {reservation.doubleSlot?
              <li>
                <div className="icon">
                  <ReactSVG src={iconClockExtra} />
                </div>
                {t("Extra Time")}
              </li>
              :null}
              {reservation.chabadBor?
              <li>
                <div className="icon">
                  <ReactSVG src={iconChabadBor} />
                </div>
                {t("Chabad Bor")}
              </li>
              :null}
              {reservation.balance>0?
              <li>
                <div className="icon">
                  <ReactSVG src={moneyOwed} />
                </div>
                {t("Balance")}:
                <div className="price"><CurrencyFormat value={reservation.balance} /></div>
              </li>
              :null}
              </ul>
              </div>
            </>
            }}}
            </SettingsContext.Consumer>
          <div className="mb-4">
            <Button className="mie-3" size="lg" type="secondary" onClick={() => this.handleScreenChange('updateAtReception')}>{t('Change Details')}</Button>
            <Button size="lg" type="primary" onClick={() => this.handleScreenChange(reservation.balance>0?'pay':'print')}>{reservation.balance>0?t('Pay and Check-In'):t('Continue')}</Button>
          </div>
          <div>
            <Button type="outline-primary" onClick={() => this.handleScreenChange('enterCode', { resetReservationCode: true })}>{t('Cancel')}</Button>
          </div>
        </div>
        break;
      case "merchandise":
        screen = <KioskMerchandise reservation={reservation} handleScreenChange={this.handleScreenChange} handleUpdateReservation={this.handleUpdateReservation}/>
        break;
      case "excludedAttendant":
        screen = <KioskExcludedAttendant reservation={reservation} handleScreenChange={this.handleScreenChange} handleUpdateReservation={this.handleUpdateReservation}/>
        break;
      case "pay":
        screen = 
        <div className="kiosk-pay">
          {error?<Alert color="danger">{t(error)}</Alert>:null}
          <SettingsContext.Consumer>
            {({settings, selCardReader}) => {
              if((settings.ccProcessorType && (settings.ccProcessorType.value==='icount'||settings.ccProcessorType.value==='cardknox')) && selCardReader){
                return <div className="mb-5">
                  <div className="balance">
                    <div className="icon">
                      <ReactSVG src={moneyOwed} />
                    </div>
                    {t("Balance")}:
                    <div className="price"><CurrencyFormat value={reservation.balance} /></div>
                  </div>
                  {(settings && settings.reservationsUseGuestExcludedAttendants && settings.reservationsUseGuestExcludedAttendants.value==="True") && reservation.user.phoneNumber.slice(-10)==='0000000000'?
                    <KioskExcludedAttendant excludeButton={true} reservation={reservation} handleScreenChange={this.handleScreenChange}/>
                  :null}
                  <KioskMerchandise merchButton={true} reservation={reservation} handleScreenChange={this.handleScreenChange}/>
                  {settings.fridayLocationSystem&&settings.fridayLocationSystem.value==="True"&&settings.shabbosMode&&settings.shabbosMode.value?
                    <Button className="d-block mt-4 mb-4 mx-auto" size="lg" type="secondary" onClick={this.modalToggleFridayLocation}>{reservation.fridayLocationId?t("Update Friday Location"):t("Add Friday Location")}</Button>
                  :null}
                  <Button type="circle-big" text={t("Pay by card")} loading={isSubmitting} onClick={this.handleChargeTerminalICount}></Button>
                </div>
              }
            }}
          </SettingsContext.Consumer>
          <div>
            <Button className="mie-3" type="outline-primary" disabled={isSubmitting} onClick={() => this.handleScreenChange(siteSettings.onlyKioskGuestWalkin?'welcome':'enterCode', { resetReservationCode: true })}>{t('Cancel')}</Button>
          </div>
        </div>
        break;
      case "print":
        screen = <div>
          <div className="instructions">
            {!reservation.advanceReservation?<div className="mb-3">{t("Reservation Code")}: <b>{reservation.reservationCode}</b></div>:null}
            {savedPrinter?t('kioskCheckinInstructionsReceipt'):t('kioskCheckinInstructions')}
          </div>
          <div className="mb-5">
            <Button type="circle-big" icon={<ReactSVG src={iconPrinter} />} text={t("Check In")} loading={isSubmitting} onClick={this.handleCheckin}></Button>
          </div>
          <div>
            <Button type="outline-primary" onClick={() => this.handleScreenChange(siteSettings.onlyKioskGuestWalkin?'welcome':'enterCode' , { resetReservationCode: true })}>{t('Cancel')}</Button>
          </div>
        </div>
        break;
      case "end":
        screen = <div>
          <div className="instructions">
            <div className="large">
              {t('kioskYouAreCheckedIn')}
            </div>
            {this.props.id==='parking'?
              <>
                {reservation.reservationStatus==="Waiting"||(reservation.reservationStatus==="Assigned"&&reservation.room.id>=15)?<FontAwesomeIcon icon="arrow-circle-right" className="icon-arrow" />:null}
                {reservation.reservationStatus==="Assigned"&&reservation.room.id<=14?<FontAwesomeIcon icon="arrow-circle-left" className="icon-arrow" />:null}
              </>
            :null}
            {reservation.reservationStatus==="Waiting" && !reservation.roomIdPreassign?
              <div>{savedPrinter?t('kioskTakeReceiptWaitingRoom'):t('kioskWaitingRoom')}</div>
            :null}
            {reservation.reservationStatus==="Waiting" && (reservation.roomIdPreassign || reservation.kallah)?
              <div>{t('preassignedWaitingText')}</div>
            :null}
            {reservation.reservationStatus==="Assigned"?
              <div>{savedPrinter?t('kioskAssignedReceipt'):t('kioskAssigned')} {reservation.room.id}</div>
            :null}
          </div>
        </div>
        break;
      case "updateAtReception":
        screen = <div>
          <div className="instructions">
            <div className="large">
              {t('Please visit the receptionist to change the details of your reservation.')}
            </div>
          </div>
        </div>
        break;
      case "error":
        screen =  <div>
        <div className="instructions">
          <div className="large">
            {t('kioskErrorTitle')}
          </div>
          <div>{t('kioskErrorSubtitle')}</div>
        </div>
      </div>
        break;
      default:
        screen = <div></div>
        break;
    }

    return (
      <div className={'container-page view-kiosk lang-' + i18n.language}>
        <SignalR setExitScreen onEntryDoorOpen={() => this.handleEntryDoorOpened()} />
        <SettingsContext.Consumer>
        {({settings}) =>{
          if(settings){
            let openTime = settings.openTime ? settings.openTime.value : null;
            let checkinbeforeopen = settings.checkinBeforeOpenMinutes && settings.checkinBeforeOpenMinutes.value ? settings.checkinBeforeOpenMinutes.value : null;
            let entryCutoff = moment(openTime).subtract(checkinbeforeopen,'m'); 
          return <KioskAdmin handleEarlyCheckin={this.handleScreenChange} handleKioskPrinterSelected={this.handleKioskPrinterSelected} siteSettings={siteSettings} beforeCheckinAllowed={checkinbeforeopen && moment(this.state.time).subtract(settings.offset&&settings.offset.value,'seconds').isBefore(moment(entryCutoff))} />
          }
        }}
        </SettingsContext.Consumer>
        <header className="header">
          <div>
            <div className="header-left">
              <img src={logo} className="logo" alt={logoImageAltText}/>            
            </div>
            <div className="header-right">
              <Clock />
              <Clock type="fullDate" />
            </div>
          </div>
          <SettingsContext.Consumer>
            {({settings}) =>{
              if(settings&&settings.fridayPrep&&settings.fridayPrep.value==="True"&&settings.shabbosMode&&settings.shabbosMode.value===true){
                return(<div>
                  <div className="header-center header-zman">
                    <ZmanTevilah showFridayClosing={true} showCandleLighting={true} settings={settings} />
                  </div>
                </div>)
              }
            }}
          </SettingsContext.Consumer>
        </header>
        <div className="container-body">
          {!siteSettings.onlyEnglishOnKiosk?<LanguageSelector />:null}
          {screen}
          <SettingsContext.Consumer>
            {({settings}) =>{
              if(settings&&settings.fridayLocationSystem&&settings.fridayLocationSystem.value==="True"&&settings.shabbosMode&&settings.shabbosMode.value){
                return <Modal isOpen={this.state.modalFridayLocation} toggle={this.modalToggleFridayLocation} centered={true} modalClassName="modal-fridayLocation">
                  <div className="modal-header">
                    {t("Shabbos/Yom Tov Tevilah Location")}
                    <button type="button" onClick={this.modalToggleFridayLocation} className="close" aria-label="Close"><span aria-hidden="true">×</span></button>
                  </div>
                  <ModalBody>
                    <FridayLocation reservation={reservation} toggle={this.modalToggleFridayLocation} handleUpdateReservation={this.handleUpdateReservation} fridayCanContinue={this.fridayCanContinue} infoRequired={settings.fridayLocationSystemRequired&&settings.fridayLocationSystemRequired.value==="True"} handleScreenChange={this.handleScreenChange} cancelLink="/kiosk"/>
                  </ModalBody>
                </Modal>
              }
            }}
          </SettingsContext.Consumer>
        </div>
      </div>
    );
  }
}

export default withTranslation()(KioskView);
